/**
 * KAN-924: "Вернуть в работу" клиента с закрытым исходом (lost или won).
 * Запрос, тост и обновление тех же списков, что после действий с мусором
 * (invalidateClientLists из useClientJunk).
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { clientsApi } from '@/services/api/clients';
import { extractErrorMessage } from '@/lib/extractErrorMessage';
import { ANY_UUID } from '@/lib/managerAccess';
import { invalidateClientLists } from '@/hooks/useClientJunk';

/** Адрес действия для проверки доступа (useCanCallApi), по образцу UUID. */
export const CLIENT_REOPEN_ACCESS_URL = `/api/v1/clients/${ANY_UUID}/reopen/`;

export function useClientReopen(onDone?: (clientId: string) => void) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (clientId: string) => clientsApi.reopen(clientId),
    onSuccess: (_client, clientId) => {
      toast.success('Клиент возвращён в работу');
      invalidateClientLists(queryClient, clientId);
      onDone?.(clientId);
    },
    onError: (error) => {
      toast.error(extractErrorMessage(error, 'Не удалось вернуть клиента в работу'));
    },
  });
}
